var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderMsgCard"},[_vm._t("card-name"),_vm._t("card-count")],2)}
var staticRenderFns = []

export { render, staticRenderFns }